import { render } from "./customTabs.vue?vue&type=template&id=31471330&scoped=true"
import script from "./customTabs.ts?vue&type=script&lang=js"
export * from "./customTabs.ts?vue&type=script&lang=js"

import "./customTabs.scss?vue&type=style&index=0&id=31471330&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31471330"]])

export default __exports__